import key from 'keyboard-shortcut';

export const initializeShortcuts = () => {
  key('d o m e n i c', function (e) {
    var audio = new Audio('/sounds/heehaw.wav');
    audio.play();
  });
};
